import type { HelpFile } from '../../types/help'
import { MyDelegationsTestIds, MyDelegationsTabId } from '../../../testids/MyDelegationsTestIds'

export const myDelegationsHelp: HelpFile = {
  docPage: '/docs/my-iam/delegations',
  texts: {
    [MyDelegationsTestIds.myDelegationsPage]:
      'Temporäre Übertragung der Genehmigungsbefugnis an eine Vertretung — Delegierungen anlegen, verfolgen und widerrufen.',
    [MyDelegationsTestIds.tab(MyDelegationsTabId.Outgoing)]:
      'Hier angelegte Delegierungen — Genehmigungsbefugnisse, die an andere übertragen wurden.',
    [MyDelegationsTestIds.tab(MyDelegationsTabId.Incoming)]:
      'Von anderen erteilte Delegierungen — empfangene Genehmigungsbefugnisse.',
    [MyDelegationsTestIds.outgoingDelegationsSection]: null,
    [MyDelegationsTestIds.incomingDelegationsSection]: null,
    [MyDelegationsTestIds.createDelegationBtn]:
      'Delegierung anlegen — eine oder mehrere Vertretungen und einen Gültigkeitszeitraum wählen.',
    [MyDelegationsTestIds.colDelegator]: null,
    [MyDelegationsTestIds.colDeputy]: null,
    [MyDelegationsTestIds.colStartAt]:
      'Datum, ab dem die Delegierung aktiv ist.',
    [MyDelegationsTestIds.colEndAt]:
      'Datum, an dem die Delegierung endet — leer bei dauerhaften Delegierungen.',
    [MyDelegationsTestIds.colReason]: null,
    [MyDelegationsTestIds.colStatus]: null,
    [MyDelegationsTestIds.colWorkflowStep]:
      'Genehmigungsschritt im Workflow, für den diese Delegierung gilt.',
    [MyDelegationsTestIds.colActions]:
      'Zeilenaktion — diese Delegierung widerrufen.',
  },
}
